<template>
  <!-- 业务订阅组件 -->
  <div class="businessSubscription" id="businessSubscriptionLayout" v-show="layoutShow">
    <div class="businessSubscriptionLayout commomLayout">
      <div class="content">
        <div class="layTop">
          <div class="layTitle">业务订阅</div>
          <a href="javascript:;" class="layoutCloseBtn" @click="closeLayout()">
            <img src="@/common/img/close.png" />
          </a>
        </div>
        <div class="layCon">
          <div class="pageTitle">
            <div class="name">选择业务类型</div>
            <div class="msg">平台会根据你的选择推荐相关的标讯</div>
          </div>

          <div class="filterDiv" v-for="(item , index) in loadBusinessTypeList" v-bind:key="index">
            <searchItem
              :title="item.name"
              :dataId="item.id"
              type="normal"
              :items="item.list"
              ref="mobileType"
            ></searchItem>
          </div>
          
        </div>
        <div class="layButton">
          <a href="javascript:;" class="submitBtn" @click="getParams()">确定</a>
          <a href="javascript:;" class="cancelBtn" @click="closeLayout()">取消</a>
        </div>
      </div>
      <div class="commomLayoutBg"></div>
    </div>
  </div>
</template>

<script>
import "@/components/businessSubscription/css/businessSubscription.css"; //页面样式
import searchItem from "@/components/searchItem/searchItem.vue"; //条件过滤组件
import { Message } from 'element-ui'
export default {
  name: "businessSubscriptionLayout",
  components: {
    searchItem // 条件过滤组件
  },
  data() {
    return {
      layoutShow:true, //业务订阅弹窗的状态
      loadBusinessTypeList : [
        {name:"通信行业" , id:1 , list : []} ,
        {name:"电力行业" , id:2 , list : []} ,
        {name:"政府行业" , id:3 , list : []}
      ]
    };
  },
  methods: {
    //获取业务类型
    getBusinessType: function() {
      var that = this;

      for(var index = 0 ; index < that.loadBusinessTypeList.length ; index++){
        let itemIndex = index;

        that.requestApi({
          method: "get",
          url: "/api/ztb/projectBusinessType/getBusinessTypeJsonByGuildId",
          data : {
            guildId : that.loadBusinessTypeList[itemIndex].id
          },
          then(data) {
            that.loadBusinessTypeList[itemIndex].list = that.hanldBusinessType(data.data);
          }
        });
      }

    },

    hanldBusinessType(dataStr){
        var businessType = JSON.parse(dataStr);        
        for (var i = 0; i < businessType.length; i++) {
          var bus = businessType[i];
          bus.id = i;
          bus.state = 0;
          delete bus.list
        }

        return businessType;
    },

    //关闭弹窗
    closeLayout:function(){
        var that = this;
        that.layoutShow = false;
    },

    getParams:function(){
        var that = this;
        // 获取业务分类  提交格式：[{"guildId":1,"businessTypes":[{"businessType":"ICT","minorBusinessTypes":["ICT","ICT1"]},"provinces":[1,2,3,4]]

        if(that.$refs.mobileType != null){
          var paramArray = new Array();
          for(var itemIndex = 0 ; itemIndex < that.$refs.mobileType.length ; itemIndex++){
            let index = itemIndex;
            let obj = new Object();
            // 行业类型
            obj['guildId'] = that.$refs.mobileType[index].dataId;

            // 组装业务分类
            let mobileTypeArray = that.$refs.mobileType[index].getParam();
 
            let typeArray = new Array();
            for(var typeArrayIndex = 0 ; typeArrayIndex < mobileTypeArray.length ; typeArrayIndex++){
              typeArray.push({
                businessType : mobileTypeArray[typeArrayIndex].name
              });
            }
            obj['businessTypes'] = typeArray;
            if(typeArray.length > 0){
              paramArray.push(obj);
            }
          }

          that.requestApi({
            method: "post",
            url: "/api/user/userTag/addOrUpdateUserTag",
            data : {
              userTagJson : JSON.stringify(paramArray)
            },
            then(data) {
              Message({
                message: "业务订阅添加成功",
                type: "success"
              });

              that.layoutShow = false;
            }
          });
        }

    }
  },

  created() {
    var that = this;
    that.getBusinessType(); //获取业务类型
  },

  /**
   * 模板渲染成html后调用
   */
  mounted() {
    var that = this;   
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/businessSubscription/businessSubscription.vue